(function () {
  const initSlider = (panel) => {
    if (panel.dataset.familyInitialised) return;

    const sliderEl = panel.querySelector('.family-selector__slider');
    const wrapperEl = panel.querySelector('.family-selector__wrapper');
    const slides = panel.querySelectorAll('.family-selector__slide');
    const progressBar = panel.querySelector('.family-selector__bar');

    if (!sliderEl || !wrapperEl || !slides.length) return;

    panel.dataset.familyInitialised = 'true';

    new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 400,
      allowTouchMove: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: progressBar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
    });
  };

  const toggleTabs = (root) => {
    const tabs = root.querySelectorAll('.family-selector__tab');
    const panels = root.querySelectorAll('.family-selector__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.classList.contains('active')) return;

        const target = tab.dataset.familyTab;

        tabs.forEach((el) => {
          el.classList.remove('active');
          el.setAttribute('aria-selected', 'false');
        });
        panels.forEach((panel) => {
          panel.classList.remove('active');
          if (panel.swiper) panel.swiper.slideTo(0, 0);
        });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = root.querySelector(
          `.family-selector__panel[data-family-panel="${target}"]`
        );
        if (activePanel) activePanel.classList.add('active');
      });
    });
  };

  const initFamilySelector = (root) => {
    if (!root || !root.classList.contains('family-selector')) return;

    root.querySelectorAll('.family-selector__panel').forEach(initSlider);
    toggleTabs(root);
  };

  document.querySelectorAll('.family-selector').forEach(initFamilySelector);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.family-selector');
    if (root) initFamilySelector(root);
  });
})();
